import styled from 'styled-components';

const StyledRowQuotes = styled.div`
  padding-bottom: 128px;
  &:last-child{
    padding-bottom: 0;
  }
  .avatar{
    position:relative;
    margin-left: 0;
    width: 128px;
    height: 128px;
    border-radius: 50%;
    overflow: hidden;
    margin-bottom: 32px;
  }
  .avatar img {
    display: block;
    width: 100%;
  }
  p{
    color: ${ props => props.theme.colors.grey_500};
  }
  p.quote--name{
    padding-top: 32px;
    padding-bottom: 24px;
    color: ${ props => props.theme.colors.grey_800};
  }
  p.quote--company{
    color: #000;
    span{
      color: ${ props => props.theme.colors.green_secondary};
    }
  }
  @media screen and (max-width: 1023px){
    padding-bottom: 80px;
    &:last-child{
      padding-bottom: 0;
    }
    p.quote--name{
      padding-top: 24px;
      padding-bottom: 24px;
    }
    .avatar{
      position:relative;
      margin-left: 0;
      width: 80px;
      height: 80px;
      border-radius: 50%;
      overflow: hidden;
      margin-bottom: 16px;
    }
  }
  @media screen and (max-width: 767px){
    padding-bottom: 64px;
    &:last-child{
      padding-bottom: 0;
    }
    p.quote--name{
      padding-top: 24px;
      padding-bottom: 16px;
    }
  }
`;

export {
  StyledRowQuotes,
};

